export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'PT',
  'merchantReturnLink': 'https://www.timberland.pt/pt-pt/ajuda/como-fazer-uma-devolucao',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
